"use client";

import { useProgress } from "@/app/_contexts/ProgressProvider";
import errorAnimation from "@/public/animations/Error2.json";
import successAnimation from "@/public/animations/Success.json";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import Lottie from "lottie-react";
import { useState } from "react";

export function ProgressDialog() {
  const { active, title, status, close, message, buttonLabel } = useProgress();

  const [_animationDone, setAnimationDone] = useState(false);

  // useEffect(() => {
  //   if (status === "success" && animationDone) {
  //     const timeout = setTimeout(() => {
  //       close();
  //     }, 1000);
  //     return () => clearTimeout(timeout);
  //   }
  // }, [status, animationDone, close]);

  if (!active) return null;

  const VISUAL_HEIGHT = 150;

  const renderLoading = () => (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Box
        sx={{
          height: VISUAL_HEIGHT,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <CircularProgress />
      </Box>
      <Typography
        variant="body2"
        sx={{ mt: 2, whiteSpace: "pre-line", textAlign: "center", height: 50 }}
      >
        {message || "Bitte warten…"}
      </Typography>
      <Box
        sx={{
          mt: 3,
          height: 38,
          width: "100%",
        }}
      />
    </Box>
  );

  const renderSuccess = () => {
    const label = buttonLabel || "Schließen";
    return (
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        <Box
          sx={{
            height: VISUAL_HEIGHT,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Lottie
            animationData={successAnimation}
            loop={false}
            autoplay
            onComplete={() => setAnimationDone(true)}
            style={{ height: VISUAL_HEIGHT }}
          />
        </Box>
        <Typography
          variant="body2"
          sx={{
            mt: 2,
            whiteSpace: "pre-line",
            textAlign: "center",
            height: 50,
          }}
          color="success.main"
        >
          {message || "Vorgang erfolgreich abgeschlossen!"}
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <Button onClick={close} variant="outlined">
            {label}
          </Button>
        </Box>
      </Box>
    );
  };

  const renderError = () => {
    const label = buttonLabel || "Entwürfe anzeigen";
    return (
      <>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              height: VISUAL_HEIGHT,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Lottie
              animationData={errorAnimation}
              loop={false}
              autoplay
              style={{ height: VISUAL_HEIGHT }}
            />
          </Box>
          <Typography
            variant="body2"
            sx={{
              mt: 2,
              whiteSpace: "pre-line",
              textAlign: "center",
              height: 50,
            }}
            color="error"
          >
            {message || "Es sind Fehler aufgetreten."}
          </Typography>
          <Box
            sx={{
              mt: 3,
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <Button onClick={close} variant="outlined">
              {label}
            </Button>
          </Box>
        </Box>
      </>
    );
  };

  return (
    <Dialog open fullWidth maxWidth="xs">
      <DialogTitle>{title || "Vorgang läuft..."}</DialogTitle>
      <DialogContent>
        {status === "loading" && renderLoading()}
        {status === "success" && renderSuccess()}
        {status === "error" && renderError()}
      </DialogContent>
    </Dialog>
  );
}
